import React from 'react';
import {connect} from "react-redux";
import ModalDialog from "../../../ui/ModalDialog/ModalDialog";
import {showOverQuota} from "../../../store/modalsSlice";

const OverQuota = (props) => {
	const handleClose = () => {
		props.showOverQuota(false);
	};

	return (
		<ModalDialog
			open={!!props.showingOverQuota} hideCancel={true}
			handleClose={handleClose} handleSubmit={handleClose} title='Over Quota'
			style={{height: '100%'}} submitString='Okay'
		>
			<p>You're currently not receiving alerts, as you're over the quota. You can get up to {props.overQuota} alerts
				per day, on a rolling basis. Please update your filters to be more picky!</p>
		</ModalDialog>
	);
};

const mapStateToProps = (state) => {
	return {
		showingOverQuota: state.modals.showingOverQuota,
		overQuota: state.core.overQuota
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		showOverQuota: (val) => dispatch(showOverQuota(val))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(OverQuota);